import { render, staticRenderFns } from "./DadosDaTurmaComponent.vue?vue&type=template&id=c3a05422"
import script from "./DadosDaTurmaComponent.vue?vue&type=script&lang=js"
export * from "./DadosDaTurmaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports